var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7207 22.9569H23.4781L23.4783 22.9568C23.7664 22.9568 24.0002 23.1906 24 23.4786C24 23.7665 23.7664 24.0003 23.4783 24.0003H20.1992C19.9113 24.0003 19.6775 23.7667 19.6775 23.4786V1.04361H5.51165L16.1688 2.46462C16.4281 2.49923 16.6213 2.7203 16.6213 2.98161L16.6211 21.8385C16.6211 22.0998 16.4279 22.3207 16.1686 22.3555L3.8703 23.995C3.84791 23.9983 3.82553 23.9999 3.80333 23.9999L3.80133 24.0001H0.521699C0.23383 24.0001 0 23.7665 0 23.4784C0 23.1906 0.233639 22.9567 0.521699 22.9567H3.27963V0.521698C3.27963 0.23383 3.51327 0 3.80133 0L20.199 0.000181881C20.4869 0.000181881 20.7207 0.233821 20.7207 0.52188V22.9569ZM4.32308 22.883L15.5774 21.3821V3.43867L4.32308 1.93777V22.883ZM14.5714 11.3854C14.5714 12.3512 13.7857 13.1369 12.8196 13.1369C11.854 13.1369 11.0683 12.3515 11.0687 11.3854C11.0687 10.4197 11.854 9.63396 12.8196 9.63396C13.7857 9.63396 14.5714 10.4197 14.5714 11.3854ZM13.5278 11.3858C13.5278 10.9955 13.2105 10.6778 12.8196 10.6778C12.4291 10.6778 12.1121 10.9955 12.1121 11.3858C12.1121 11.7761 12.4293 12.0939 12.8196 12.0939C13.2103 12.0939 13.5278 11.7761 13.5278 11.3858Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorIcon);
export default __webpack_public_path__ + "static/media/door-icon.5094fc1a5c5f3d0b422fee448bda905b.svg";
export { ForwardRef as ReactComponent };